import { withInstall } from '@fx-front-framework/utils/with-install'
import VRosePieChart from './src/index.vue'

export const FxVRosePieChart = withInstall(VRosePieChart)
export default FxVRosePieChart
